module.exports = __webpack_public_path__ + "static/img/dev3.455774f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/dev3.jpg
// module id = 0z5I
// module chunks = 3